export { RecordDetails } from './RecordDetails';
export { VisitsHistoryTab } from './VisitsHistoryTab';
export { ClientData } from './ClientData';
export { ClientCard } from './ClientCard';
export { RecordHistory } from './RecordHistory';
export { RecordPayment } from './RecordPayment';
export { TechnologicalMap } from './TechnologicalMap';
export { MedicalCard } from './MedicalCard';
